import { StatusCodes } from 'http-status-codes';
import cookie from 'react-cookie';
import { toast } from 'react-toastify';
import { updateSession } from './session';

export const BASE_URL = process.env.REACT_APP_REST_BASE_URL;

export const HEADER_JWT_PAYLOAD = 'X-Jwt-Payload';
export const getJwtPayload = () => cookie.load('jwt.payload');

class JsonError extends Error {
  json;

  constructor(message, json) {
    super(message);
    this.json = json;
  }

  get json() {
    return this.json;
  }
}

export const createImageFromBase64 = (imageBase64) => {
  if (imageBase64 !== '') {
    const byteCharacters = atob(imageBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const image = new Blob([byteArray], { type: 'image/jpeg' });
    return URL.createObjectURL(image);
  }
  return '';
};

export const createRequestProperties = (requestProperties) => {
  const { headers = {} } = requestProperties || {};

  // FIXME: proper session state handling
  const jwtPayload = getJwtPayload() || undefined;

  requestProperties = {
    method: 'get',
    cache: 'no-store',

    ...requestProperties,

    credentials: 'same-origin',

    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Pragma: 'no-cache',
      'Cache-Control': 'no-cache',

      ...headers,

      [HEADER_JWT_PAYLOAD]: jwtPayload,
    },
  };

  requestProperties = removeKeys(requestProperties);

  return requestProperties;
};

export const createMultiPartPostProperty = (requestProperties) => {
  const { headers = {} } = requestProperties || {};

  // FIXME: proper session state handling
  const jwtPayload = getJwtPayload() || undefined;

  requestProperties = {
    ...requestProperties,

    credentials: 'same-origin',

    headers: {
      ...headers,

      [HEADER_JWT_PAYLOAD]: jwtPayload,
    },
  };

  requestProperties = removeKeys(requestProperties);

  return requestProperties;
};

const removeKeys = (requestProperties) => {
  Object.keys(requestProperties)
    .forEach((key) => {
      if (requestProperties[key] === undefined) {
        delete requestProperties[key];
      }
    });

  Object.keys(requestProperties.headers)
    .forEach((key) => {
      if (requestProperties.headers[key] === undefined) {
        delete requestProperties.headers[key];
      }
    });
  return requestProperties;
};

const requestReady = (dispatch) => (response) => new Promise((resolve, reject) => {
  dispatch(updateSession);

  if (response && response.status === 401) {
    reject();
  } else {
    resolve(response);
  }
});

const handleErrors = (response) => {
  if (!response.ok) {
    throw new JsonError(response.statusText, response.json());
  }
  return response;
};

export const requestApi = (path, requestProperties, actionCreator, errorCallback, successCallback) => (dispatch) => fetch(BASE_URL + path, createRequestProperties(requestProperties))
  .then(requestReady(dispatch))
  .then(handleErrors)
  .then((response) => response.json())
  .then((json) => dispatch(actionCreator(json, dispatch)))
  .then(() => {
    if (successCallback) {
      successCallback();
    }
  })
  .catch((e) => {
    dispatch(actionCreator({data: [], hasData: false}, dispatch));
  });

export const downloadFile = (fileID, downloadURL) => {
  fetch(`${BASE_URL}${downloadURL}/${fileID}`, createRequestProperties(null))
    .then(handleErrors)
    .then((response) => {
      const filename = response.headers.get('Content-Disposition').split('filename=')[1];
      response.blob().then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
      });
    })
    .catch((err) => toast.error(err.message));
};

export const installationDocumentRequestApi = (path) => fetch(BASE_URL + path, createRequestProperties(null))
  .then(handleErrors)
  .then((response) =>
    // No content, 204, is returned by business logic. There is no JSON in this case.
    (response.status === StatusCodes.NO_CONTENT
      ? undefined
      : response.json()))
  .catch((e) => {
    if (e.json) {
      e.json.then((it) => toast.error(it.message || e.message || 'Internal server error'));
    } else {
      toast.error(e.message || 'Internal server error');
    }
  });

export const installationDocumentImagesRequestApi = (path) => fetch(BASE_URL + path, createRequestProperties(null))
  .then(handleErrors)
  .then((response) => response.json())
  .catch((e) => {
    if (e.json) {
      e.json.then((it) => toast.error(it.message || e.message || 'Internal server error'));
    } else {
      toast.error(e.message || 'Internal server error');
    }
  });

export const installationDocumentOrderUpload = (requestProperties, path) => fetch(BASE_URL + path,
  createMultiPartPostProperty(requestProperties))
  .catch((e) => {
    if (e.json) {
      e.json.then((it) => toast.error(it.message || e.message || 'Internal server error'));
    } else {
      toast.error(e.message || 'Internal server error');
    }
  });



// WEBPACK FOOTER //
// ./src/actions/helper.js